import ButtonKbpayLiveCancel from 'components/Button/ButtonKbpayLiveCancel'
import SectionLayout from 'container/SectionLayout'
import { IS_OPEN_MODAL } from 'core/store/global'
import { useSetRecoilState } from 'recoil'
import styled from 'styled-components'

const SectionLiveCancellation: React.FC = () => {
  const setIsOpenModal = useSetRecoilState(IS_OPEN_MODAL)

  const handleClickButton = () => {
    const modalData = {
      type: 'kbpay-cancel' as const,
      title: '',
      message: '',
      termsUrl: '',
      onSubmit: () => {},
    }
    setIsOpenModal(modalData)
  }

  return (
    <SectionLayout elementId="live-cancellation">
      <StyledSectionLiveCancellation>
        <StyledButtonWrapper>
          <ButtonKbpayLiveCancel onClick={handleClickButton} />
        </StyledButtonWrapper>
      </StyledSectionLiveCancellation>
    </SectionLayout>
  )
}

const StyledSectionLiveCancellation = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
`
const StyledButtonWrapper = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
`
export default SectionLiveCancellation
